import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ShieldAlert, Download } from "lucide-react";
import { CopyField } from "../components/CopyField";
import { publicLink } from "../components/ShareDialog";

export const manageLink = (token) => `${window.location.origin}/manage/${token}`;

export function downloadLinks(t, name, slug, token) {
  const text = `${name}\n\n${t("manage.public_link")}:\n${publicLink(slug)}\n\n${t("manage.private_link")}:\n${manageLink(token)}\n\n${t("manage.warning_text")}\n`;
  const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = t("manage.file_name");
  a.click();
  URL.revokeObjectURL(a.href);
}

export const LinksBlock = ({ name, slug, token, tone = "light" }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <CopyField label={t("manage.public_link")} value={publicLink(slug)} testId="public-link" tone={tone} />
      <CopyField label={t("manage.private_link")} value={manageLink(token)} testId="private-link" tone={tone} />
      <div className={`flex gap-3 rounded-2xl p-4 text-sm ${tone === "dark" ? "bg-[var(--gold)]/15 text-[var(--gold-soft)]" : "bg-[#f4e6cc] text-[#5b4626]"}`} data-testid="private-link-warning">
        <ShieldAlert size={20} className="shrink-0 mt-0.5" aria-hidden="true" />
        <div>
          <p className="font-semibold">{t("manage.warning_title")}</p>
          <p className="opacity-90 mt-1">{t("manage.warning_text")}</p>
        </div>
      </div>
      <button onClick={() => downloadLinks(t, name, slug, token)} className={tone === "dark" ? "btn-glass w-full" : "btn-ghost w-full"} data-testid="download-links-btn">
        <Download size={16} /> {t("manage.download_links")}
      </button>
    </div>
  );
};

export const ReadyPanel = ({ item, token, onClose }) => {
  const { t } = useTranslation();
  return (
    <div className="absolute inset-0 z-40 grid place-items-center p-4 bg-black/30" data-testid="ready-panel">
      <div className="glass-dark w-full max-w-lg rounded-3xl p-7 sm:p-9 anim-rise max-h-[92vh] overflow-auto">
        <p className="eyebrow !text-[var(--gold-soft)]">{item.name}</p>
        <h2 className="font-heading text-3xl sm:text-4xl mt-2">{t("scene.ready_title")}</h2>
        <p className="text-[var(--sand)]/80 mt-2 mb-6">{t("scene.ready_lead")}</p>
        <LinksBlock name={item.name} slug={item.slug} token={token} tone="dark" />
        <div className="grid sm:grid-cols-2 gap-2 mt-4">
          <Link to={`/m/${item.slug}`} className="btn-gold" data-testid="ready-open-page-btn">{t("scene.open_page")}</Link>
          <button onClick={onClose} className="btn-glass" data-testid="ready-continue-btn">{t("scene.continue_exploring")}</button>
        </div>
      </div>
    </div>
  );
};
